import React, { useState } from "react";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
// import { client } from '../../client';
import "./Footer.scss";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(true);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: "contact",
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };
    console.log(contact);
    // client.create(contact)
    //   .then(() => {
    //     setLoading(false);
    //     setIsFormSubmitted(true);
    //   })
    //   .catch((err) => console.log(err));
  };

  return (
    <>
      <h2 className="head-text">Chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:hello@micael.com" className="p-text" target="_blank">
            kuldeepnishad.singh@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+1 (123) 456-7890" className="p-text" target="_blank">
            +91 7536064444
          </a>
        </div>
        <div className="app__footer-card ">
          <img src="https://img.icons8.com/nolan/344/file.png" alt="file" />
          <a
            href="https://drive.google.com/drive/folders/1YDkj1k8B1kipvWJCSSeJw58FHHtd91vH"
            className="p-text"
            target="_blank"
          >
            Resume
          </a>
        </div>
        <div className="app__footer-card ">
          <img src="https://img.icons8.com/nolan/344/address.png" alt="file" />
          <a
            href="https://www.google.com/maps/place/Etawah,+Uttar+Pradesh/@26.787475,78.9474976,12z/data=!3m1!4b1!4m5!3m4!1s0x3975dfd884cf6219:0x6aa136334cfc04c5!8m2!3d26.7829103!4d79.027659"
            className="p-text"
            target="_blank"
          >
            Etawah, U.P
          </a>
        </div>
      </div>
      {/* {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="username"
              value={username}
              onChange={handleChangeInput}
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>
            {!loading ? "Send Message" : "Sending..."}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch!</h3>
        </div>
      )} */}
      <div className="rights_reserve">
        <div className="p-text right-align">
          {" "}
          ©️ All rights reserved to Kuldeep Singh
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
